import { __assign } from 'tslib';
import React from 'react';
import { InputAutocompleteMobile } from './Component.mobile.js';
import 'react-merge-refs';
import 'classnames';
import 'lodash.throttle';
import '../../../select/esm/mobile';
import '../../../select/esm/shared';
import '../autocomplete-mobile-field/Component.js';
import '../../../form-control/esm/mobile';
import '../../../input/esm/shared';
import '../../../shared/esm';
import '@alfalab/hooks';
import '../utils.js';

var InputAutocompleteModalMobile = React.forwardRef(function (props, ref) { return React.createElement(InputAutocompleteMobile, __assign({}, props, { ref: ref, isBottomSheet: false })); });

export { InputAutocompleteModalMobile };
